var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRellenar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 21,
    viewBox: "0 0 41 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 21,
    height: 21,
    fill: "#ECEDEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 11L39 14.4641V7.5359L33 11Z",
    fill: "#ECEDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L2 14.4641V7.5359L8 11Z",
    fill: "#ECEDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRellenar);
export default __webpack_public_path__ + "static/media/rellenar.482307926d63afe418ff417a622f08ee.svg";
export { ForwardRef as ReactComponent };